import { useGameParamsStore } from "../../store/gameParams";
import { LANGUAGES, CURRENCIES } from "../../constants";
import { ConfigParams } from "../../interfaces/interfaces";
import "./ConfigGameBar.scss";
import { useState, useEffect } from "react";
import { useGameLangStore } from "../../store/gameLanguage";
import CustomSwitch from "../CustomSwitch/CustomSwitch";
import DesktopIcon from '../../assets/desktop.svg';
import MobileIcon from '../../assets/mobile.svg';
import NewWindowIcon from '../../assets/new-window.svg';
import SameWindowIcon from '../../assets/same-window.svg';



type Props = {
  defaultGameLanguage: string;
};

export default function ConfigGameBar({defaultGameLanguage} : Props) {
  const { params, setParams } = useGameParamsStore((state) => state);
  const { lang, setLang } = useGameLangStore((state) => state);
  const [numFields, setNumFields] = useState(1);

  useEffect(() => {
    let numDisplayedInputs = 0;
    let items = document.getElementsByClassName("game-bar-config-select");
    for (let i = 0; i < items.length; i++) {
      if (getComputedStyle(items[i]).display === "block") numDisplayedInputs++;
    }
    setNumFields(numDisplayedInputs);
  }, [numFields]);

  useEffect(() => {
    defaultGameLanguage ? setLang(defaultGameLanguage) : setLang(Object.values(LANGUAGES)[0]);
  }, [defaultGameLanguage, setLang]);

  const handleChange = <P extends keyof ConfigParams>(
    prop: P,
    value: ConfigParams[P]
  ) => {
    setParams({ ...params, [prop]: value });
  };

  const handleConfigChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setParams({
      ...params,
      [e.target.name]: (e.target as HTMLInputElement).checked,
    });
  };


  return (
    <div className="game-bar">
      <div className="game-bar-config">
        {numFields > 1 ? (
          <p>Game configuration:</p>
        ) : (
          <p>Language:</p>
        )}
        <div className="game-bar-config-div">
          <select
            className="game-bar-config-select"
            value={lang}
            name="lang"
            onChange={(e) => {
              setLang(e.target.value);
            }}
          >
            {Object.entries(LANGUAGES).map((lang) => (
              <option key={lang[0]} value={lang[1]}>
                {lang[0]}
              </option>
            ))}
          </select>
          <select
            className="game-bar-config-select currency-field"
            value={params.currency}
            name="currency"
            onChange={(e) => {
              handleChange("currency", e.target.value);
            }}
          >
            {CURRENCIES.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="game-bar-option">
        <div className="game-bar-parameter">
          <p>Device:</p>
          <CustomSwitch
            name="isMobile"
            checked={params.isMobile}
            onChange={handleConfigChange} 
            onSwitchIcon={MobileIcon} 
            offSwitchIcon={DesktopIcon}/>
        </div>
        <div className="game-bar-parameter">
          <p>Open in:</p>
          <CustomSwitch
            name="newWindow"
            checked={params.newWindow}
            onChange={handleConfigChange} 
            onSwitchIcon={NewWindowIcon} 
            offSwitchIcon={SameWindowIcon}/>
        </div>
      </div>

      

    </div>
  );
}
